export const setMarkerProperty = (element, property, value) => {
  if (value) {
    element.style.setProperty(property, value);
  } else {
    element.style.removeProperty(property);
  }

  const style = element.getAttribute("style");

  if (style) {
    element.setAttribute("data-mce-style", style);
  } else {
    element.removeAttribute("style");
    element.removeAttribute("data-mce-style");
  }
};
